module.exports = __webpack_public_path__ + "img/plane-prop.d9968f73.svg";